import { render, staticRenderFns } from "./MainAmountsComponent.vue?vue&type=template&id=51ca14de&scoped=true&"
import script from "./MainAmountsComponent.vue?vue&type=script&lang=js&"
export * from "./MainAmountsComponent.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "51ca14de",
  null
  ,true
)

export default component.exports